// URL Redirects for Shop All page
document.addEventListener('DOMContentLoaded', function() {
  // Check if current URL contains collections/all and redirect to collections/shop-all
  if (window.location.pathname === '/collections/all' || 
      window.location.href.includes('collections/all')) {
    window.location.replace('/collections/shop-all');
  }
});